<!-- 
  EventStatistics.vue
  이벤트 현황 페이지
  
  - 특정 이벤트의 현황 정보 표시
  - eventId로 이벤트 정보 조회
-->
<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>
    <!-- 페이지 헤더 영역 -->
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
          <div class="title-row">
            <div>
              <h1 class="fw-bold page-title">
                {{ eventTitle }} 현황
              </h1>
              <span class="pageDesc">{{ eventTitle }} 이벤트의 현황 정보를 확인할 수 있습니다.</span>
            </div>
            <div class="header-actions">
              <div class="date-filter">
                <span class="date-label">기간 선택</span>
                <a-range-picker
                  v-model:value="dateRange"
                  :placeholder="['시작일', '종료일']"
                  format="YYYY. MM. DD."
                  @change="handleDateChange"
                  :allow-clear="false"
                />
                <div class="date-filter-buttons">
                  <a-button 
                    v-for="option in dateFilterOptions"
                    :key="option.value"
                    size="small" 
                    @click="setDateRange(option.value)" 
                    :type="dateFilter === option.value ? 'primary' : 'default'"
                  >
                    {{ option.label }}
                  </a-button>
                </div>
              </div>
              <a-button class="back-button" @click="goBack">
                <i class="fa fa-arrow-left" style="margin-right: 5px"></i> 뒤로가기
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 콘텐츠 영역 -->
    <div class="card-body px-0 pt-3 pb-2">
      <div class="card content-wrap-card">
        <div class="section-header">
          <div class="section-title">
            <i class="fa fa-chart-line" style="margin-right: 8px"></i>이벤트 현황
          </div>
        </div>
        
        <div class="content-section" v-if="!loadingStats">
          <!-- 전체 현황 요약 -->
          <div class="stats-section">
            <div class="stats-title">
              <i class="fa fa-chart-bar"></i>
              <span>전체 현황 요약</span>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 400px;">
                    <p><strong>전체 현황 요약</strong></p>
                    <p>메시지 발송부터 최종 참여까지의 전체 현황을 한눈에 볼 수 있습니다.</p>
                    <br/>
                    <p><strong>활용 팁:</strong></p>
                    <p>• 전환율: 응모한사람 ÷ 알림톡발송성공건수 × 100</p>
                    <p>• 참여 완성도: 만족도후기모두작성 ÷ 응모한사람 × 100</p>
                    <p>• 메시지 효율성: 알림톡발송성공건수 ÷ 메시지발송시도건수 × 100</p>
                  </div>
                </template>
                <i class="fa fa-question-circle help-icon"></i>
              </a-tooltip>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 800px;">
                    <p><strong>🔧 백엔드 데이터 집계 로직</strong></p>
                    <br/>
                    <p><strong>1. 기본 집계 원칙</strong></p>
                    <ul>
                      <li>모든 데이터는 MongoDB의 eventattendees 컬렉션에서 집계</li>
                      <li>날짜 필터는 messageSendHistory.requestedAt 기준</li>
                      <li>중복 제거는 고유 문서(_id) 기준</li>
                    </ul>
                    <br/>
                    <p><strong>2. 주요 필드 구조</strong></p>
                    <ul>
                      <li><strong>messageSendHistory[]</strong>: 메시지 발송 이력 배열</li>
                      <li><strong>activities[]</strong>: 사용자 활동 이력 배열</li>
                      <li><strong>certificate</strong>: 수술 인증서 정보</li>
                      <li><strong>status</strong>: 참여자 상태 (viewed, clicked 등)</li>
                    </ul>
                    <br/>
                    <p><strong>3. 날짜 필터 적용</strong></p>
                    <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
messageSendHistory: {
  $elemMatch: {
    requestedAt: {
      $gte: startDate,
      $lte: endDate
    }
  }
}</pre>
                  </div>
                </template>
                <i class="fa fa-exclamation-circle backend-icon"></i>
              </a-tooltip>
              
                <!-- 사용자 타입 필터 -->
                <div class="view-switcher">
                  <a-radio-group v-model:value="selectedUserType" @change="handleUserTypeChange" size="small">
                    <a-tooltip placement="top">
                      <template #title>시술받은 환자 (고객)</template>
                      <a-radio-button value="customer">시술받은 환자</a-radio-button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template #title>환자의 친구</template>
                      <a-radio-button value="customer_friend">환자의 친구</a-radio-button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template #title>친구의 친구</template>
                      <a-radio-button value="friend_of_friend">친구의 친구</a-radio-button>
                    </a-tooltip>
                  </a-radio-group>
                </div>
                <!-- 데이터 기준 필터 -->
                <!-- <div class="view-switcher">
                  <a-radio-group v-model:value="selectedView" @change="handleViewChange" size="small">
                    <a-tooltip placement="top">
                      <template #title>중복 제거된 실제 대상자 수</template>
                      <a-radio-button value="uniqueRecipient">고유 수신자</a-radio-button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template #title>재발송 포함 모든 메시지 건수</template>
                      <a-radio-button value="messageCount">메시지 건수</a-radio-button>
                    </a-tooltip>
                  </a-radio-group>
                </div> -->
              </div>
            <div class="stats-subtitle">메시지 발송부터 최종 참여까지의 전체 현황</div>
            
            <div :class="['stats-row', `user-type-${selectedUserType}`]">
              <div 
                v-for="stat in getVisibleStatCards()" 
                :key="stat.key"
                :class="['stat-card', stat.colorClass]"
              >
                <div class="stat-icons">
                  <a-tooltip placement="top" v-if="stat.tooltip">
                    <template #title>
                      <div style="max-width: 350px;" v-html="stat.tooltip"></div>
                    </template>
                    <i class="fa fa-question-circle stat-help-icon"></i>
                  </a-tooltip>
                  <a-tooltip placement="top" v-if="stat.backendTooltip">
                    <template #title>
                      <div style="max-width: 700px;" v-html="stat.backendTooltip"></div>
                    </template>
                    <i class="fa fa-exclamation-circle stat-backend-icon"></i>
                  </a-tooltip>
                </div>
                <div class="stat-number">
                  {{ stat.isPercent ? stat.value + '%' : (stat.value?stat.value.toLocaleString():stat.value) }}
                </div>
                <div class="stat-desc">{{ stat.label }}</div>
                <div class="stat-percent">{{ stat.percent }}{{ typeof stat.percent === 'string' && !stat.percent.includes('%') && !stat.percent.includes('명') && !stat.percent.includes('회') ? '%' : '' }}</div>
              </div>
            </div>
          </div>

          <!-- 대상자 행동 분석 (퍼널) -->
          <div class="stats-section">
            <div class="stats-title">
              <i class="fa fa-filter"></i>
              <span>대상자 행동 분석 (퍼널)</span>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 800px;">
                    <p><strong>🔧 퍼널 백엔드 데이터 집계 로직</strong></p>
                    <br/>
                    <p><strong>1. 집계 기준</strong></p>
                    <ul>
                      <li>모든 단계는 고유 사용자 수 (중복 제거)</li>
                      <li>activities[].type으로 사용자 행동 추적</li>
                      <li>status로 메시지 클릭/조회 확인</li>
                    </ul>
                    <br/>
                    <p><strong>2. 주요 Activity Types</strong></p>
                    <ul>
                      <li>'카카오 알림톡 하단 버튼 클릭': 이벤트 페이지 진입</li>
                      <li>'이벤트 참여하기 클릭': 참여 시작</li>
                      <li>'스마일 만족도 제출 완료': 만족도 작성</li>
                      <li>'스마일 경험 공유 완료': 후기 작성</li>
                    </ul>
                    <br/>
                    <p><strong>3. 전환율 계산</strong></p>
                    <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
각 단계 전환율 = (현재 단계 수 / 이전 단계 수) × 100
전체 전환율 = (최종 단계 수 / 첫 단계 수) × 100</pre>
                  </div>
                </template>
                <i class="fa fa-exclamation-circle backend-icon"></i>
              </a-tooltip>
            </div>
            <div class="stats-subtitle">이벤트 대상자부터 최종 참여까지의 전환 과정</div>
            
            <div class="funnel-stats">
              <div 
                v-for="(item, index) in getFunnelData()" 
                :key="item.key"
                :class="['funnel-item', item.colorClass]"
              >
                <a-tooltip placement="top" v-if="item.tooltip">
                  <template #title>
                    <div style="max-width: 400px;" v-html="item.tooltip"></div>
                  </template>
                  <i class="fa fa-question-circle funnel-help-icon"></i>
                </a-tooltip>
                <a-tooltip placement="top" v-if="item.hasWarning && item.warningTooltip">
                  <template #title>
                    <div v-html="item.warningTooltip"></div>
                  </template>
                  <i class="fa fa-exclamation-circle funnel-warning-icon"></i>
                </a-tooltip>
                <div class="funnel-bar" :style="{ width: item.width + '%' }"></div>
                <div class="funnel-content">
                  <div class="funnel-number">{{ item.number.toLocaleString() }}</div>
                  <div class="funnel-desc" v-html="item.desc"></div>
                  <div class="funnel-percent">{{ item.percent }}%</div>
                  <div class="funnel-change" v-if="item.change !== 0">
                    -{{ Math.abs(item.change).toLocaleString() }}
                  </div>
                </div>
                <div class="funnel-arrow" v-if="index < getFunnelData().length - 1">→</div>
              </div>
            </div>
            
          </div>

          <!-- 병원별 집계 -->
          <div class="stats-section" v-if="viewOptions && viewOptions[selectedView]?.data?.hospitalBreakdown?.length > 0">
            <div class="stats-title">
              <i class="fa fa-hospital"></i>
              <span>병원별 집계</span>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 400px;">
                    <p><strong>병원별 집계</strong></p>
                    <p>병원별 응답자 현황과 참여 성과를 확인할 수 있습니다.</p>
                    <br/>
                    <p><strong>표시 기준:</strong></p>
                    <p>• 응모한사람 기준 상위 20개 병원</p>
                    <p>• 완전작성률 = 만족도,후기모두작성 ÷ 응모한사람</p>
                    <p>• 날짜 필터가 적용된 결과입니다</p>
                  </div>
                </template>
                <i class="fa fa-question-circle help-icon"></i>
              </a-tooltip>
            </div>
            <div class="stats-subtitle">응답자 수 기준 상위 20개 병원의 상세 현황</div>
            
            <div class="hospital-table-wrapper">
              <a-table 
                :columns="hospitalColumns"
                :data-source="hospitalTableData"
                :pagination="false"
                :scroll="{ x: 1050 }"
                size="middle"
                class="hospital-breakdown-table"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'hospitalName'">
                    <div class="hospital-name">{{ text }}</div>
                  </template>
                  <template v-else-if="column.dataIndex === 'completionRate'">
                    <div class="completion-rate">
                      <span class="rate-value">{{ text }}%</span>
                      <div class="rate-bar">
                        <div class="rate-fill" :style="{ width: text + '%' }"></div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        
        <!-- 로딩 상태 -->
        <div class="content-section" v-else>
          <div class="loading-state">
            <a-spin size="large" />
            <p>통계 데이터를 불러오는 중입니다...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, reactive, computed, h } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { message, Tooltip } from 'ant-design-vue';
import eventsApis from './api';
import axios from '@/axios';
import dayjs from 'dayjs';

export default {
  name: "EventStatistics",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    
    // 상태 변수
    const eventId = ref(null);
    const eventTitle = ref('이벤트');
    const loading = ref(false);
    const loadingStats = ref(false);
    
    // API 인스턴스
    const apiInstance = ref(null);
    
    // 날짜 필터 관련
    const dateRange = ref(null);
    const dateFilter = ref('all');
    
    // 뷰 전환 관련
    const selectedView = ref('uniqueRecipient'); // 데이터 기준: uniqueRecipient, messageCount (기본값: 고유 수신자)
    // const selectedView = ref('uniqueRecipient'); // 데이터 기준: uniqueRecipient, messageCount (기본값: 고유 수신자)
    const selectedUserType = ref('customer'); // 사용자 타입: customer, customer_friend, friend_of_friend (기본값: 시술받은 환자)
    const viewOptions = ref(null);
    
    // 통계 데이터
    const dashboardStats = reactive({
      // 메시지 발송 관련
      메시지발송시도건수: 0,
      알림톡발송성공건수: 0,
      메시지발송실패건수: 0,
      
      // 응답자 통계 (새로운 구조)
      응모한사람: 0,
      만족도만작성: 0,
      후기만작성: 0,
      만족도후기모두작성: 0,
      
      // 수술 타입별 통계
      인증서없는응답자: 0,
      
      // 후기 통계
      후기작성완료건수: 0,
      
      // 카카오톡 공유 관련
      카카오톡공유한사람: 0,
      후기남긴사람: 0,
      공유후기남긴사람: 0,
      카카오톡공유하기횟수: 0,
      
      // 페이지 진입 관련
      이벤트페이지진입: 0,
      병원페이지진입: 0,
      
      // 추가 통계 (화면에 표시할 추가 항목들)
      페이지방문자수: 0,
      참여자분포: {
        만족도만: 0,
        후기만: 0,
        모두작성: 0
      },
      
      // 퍼널 상세 (추가)
      퍼널상세: {
        '1_messageRequested': 0,
        '2_messageSent': 0,
        '3_eventPageVisited': 0,
        '4_participationStarted': 0,
        '5_satisfactionPageEntered': 0,
        '6_reviewPageEntered': 0,
        '7_satisfactionSubmitted': 0,
        '8_reviewTextSubmitted': 0,
        '9_bothCompleted': 0
      }
    });
    
    // 이벤트 정보 조회
    const loadEventDetails = async () => {
      if (!eventId.value || !apiInstance.value) return;
      
      loading.value = true;
      
      try {
        await new Promise((resolve, reject) => {
          apiInstance.value.getEventById(
            eventId.value,
            (response) => {
              console.log('이벤트 상세 정보 조회 성공:', response);
              console.log('Response data:', response.data);
              
              // API 응답 구조에 맞게 데이터 추출
              const eventData = response.data?.data || response.data;
              console.log('Event data:', eventData);
              
              if (eventData && eventData.eventTitle) {
                eventTitle.value = eventData.eventTitle;
                console.log('Event title set to:', eventTitle.value);
              } else {
                console.warn('eventTitle not found in response');
                eventTitle.value = '이벤트';
              }
              resolve();
            },
            (error) => {
              console.error('이벤트 상세 정보 조회 실패:', error);
              reject(error);
            }
          );
        });
      } catch (error) {
        if (error.status === 404) {
          message.error('해당 이벤트를 찾을 수 없습니다.');
        } else {
          message.error('이벤트 정보를 불러오는 중 오류가 발생했습니다.');
        }
      } finally {
        loading.value = false;
      }
    };
    
    // 대시보드 통계 조회
    const loadDashboardStatistics = async () => {
      if (!eventId.value) return;
      
      loadingStats.value = true;
      
      try {
        let url = `/events-v2/statistics/${eventId.value}/dashboard`;
        const params = {
          userType: selectedUserType.value, // 사용자 타입 파라미터 추가
          dataView: selectedView.value // 데이터 뷰 파라미터 추가
        };
        
        // 날짜 필터가 설정된 경우 파라미터 추가
        if (dateRange.value && dateRange.value.length === 2) {
          params.startDate = dayjs(dateRange.value[0]).format('YYYY-MM-DD');
          params.endDate = dayjs(dateRange.value[1]).format('YYYY-MM-DD');
        }
        
        const response = await axios.get(url, { params });
        
        if (response.data && response.data.success && response.data.data) {
          const stats = response.data.data;
          console.log('API 응답 데이터:', stats);
          console.log('이벤트페이지진입 값:', stats.이벤트페이지진입);
          console.log('병원페이지진입 값:', stats.병원페이지진입);
          
          // viewOptions가 있는 경우 처리
          if (stats.viewOptions) {
            viewOptions.value = stats.viewOptions;
            // defaultView 설정
            if (stats.defaultView) {
              selectedView.value = stats.defaultView;
            }
            // 선택된 뷰의 데이터를 dashboardStats에 적용
            applyViewData(selectedView.value, stats);
          } else {
            // viewOptions가 없는 경우 기존 방식으로 처리 (하위 호환성)
            Object.keys(dashboardStats).forEach(key => {
              if (key === '퍼널상세' && stats.퍼널상세) {
                // 퍼널상세는 객체이므로 별도 처리
                Object.assign(dashboardStats.퍼널상세, stats.퍼널상세);
              } else if (stats[key] !== undefined) {
                dashboardStats[key] = stats[key];
              }
            });
          }
          
        }
      } catch (error) {
        console.error('대시보드 통계 조회 실패:', error);
        message.error('통계 데이터를 불러오는 중 오류가 발생했습니다.');
      } finally {
        loadingStats.value = false;
      }
    };
    
    // 선택된 뷰의 데이터를 dashboardStats에 적용
    const applyViewData = (view, stats) => {
      if (!viewOptions.value || !viewOptions.value[view]) {
        return;
      }
      
      const viewData = viewOptions.value[view].data;
      console.log('applyViewData 호출됨:', { view, stats, viewData });
      
      // 뷰 데이터를 dashboardStats에 적용
      Object.keys(viewData).forEach(key => {
        if (key === '퍼널상세' && viewData.퍼널상세) {
          // 퍼널상세는 객체이므로 별도 처리
          dashboardStats.퍼널상세 = { ...viewData.퍼널상세 };
        } else if (viewData[key] !== undefined) {
          dashboardStats[key] = viewData[key];
        }
      });
      
      // 루트 레벨의 데이터도 처리 (이벤트페이지진입, 병원페이지진입 등)
      Object.keys(stats).forEach(key => {
        if (key !== 'viewOptions' && key !== 'defaultView' && key !== '퍼널상세' && stats[key] !== undefined) {
          dashboardStats[key] = stats[key];
          console.log(`루트 레벨 데이터 매핑: ${key} = ${stats[key]}`);
        }
      });
    };
    
    // 사용자 타입 변경 핸들러
    const handleUserTypeChange = (e) => {
      const value = e.target.value;
      selectedUserType.value = value;
      // localStorage에 선택 저장
      localStorage.setItem('eventStatsUserType', value);
      // 사용자 타입이 변경되면 API를 다시 호출
      loadDashboardStatistics();
    };

    // 데이터 뷰 변경 핸들러
    const handleViewChange = (e) => {
      const value = e.target.value;
      selectedView.value = value;
      // localStorage에 선택 저장
      localStorage.setItem('eventStatsView', value);
      // 데이터 뷰가 변경되면 API를 다시 호출
      loadDashboardStatistics();
    };
    
    // 날짜 범위 설정
    const setDateRange = (type) => {
      dateFilter.value = type;
      const today = dayjs();
      
      switch (type) {
        case 'all':
          dateRange.value = null;
          break;
        case 'today':
          dateRange.value = [today, today];
          break;
        case 'week':
          dateRange.value = [today.subtract(7, 'day'), today];
          break;
        case 'month':
          dateRange.value = [today.subtract(1, 'month'), today];
          break;
      }
      
      // 통계 다시 로드
      loadDashboardStatistics();
    };
    
    // 날짜 변경 핸들러
    const handleDateChange = () => {
      dateFilter.value = 'custom';
      loadDashboardStatistics();
    };
    
    // 백분율 계산 헬퍼 함수
    const calcPercent = (value, total) => {
      if (!total || total === 0) return '0.0';
      return ((value / total) * 100).toFixed(1);
    };
    
    // 카드 표시 여부 확인
    const shouldShowCard = (stat) => {
      if (stat.showFor) {
        return stat.showFor.includes(selectedUserType.value);
      }
      return true;
    };
    
    // 표시할 카드들만 필터링
    const getVisibleStatCards = () => {
      return getStatCards().filter(stat => shouldShowCard(stat));
    };
    
    // 통계 카드 데이터 계산
    const getStatCards = () => {
      const total = selectedUserType.value === 'customer' ? dashboardStats.메시지발송시도건수 : dashboardStats.레퍼러로부터공유받은횟수;
      const responseTotal = dashboardStats.응모한사람;
      const satisfactionOrReview = dashboardStats.만족도만작성 + dashboardStats.후기만작성 + dashboardStats.만족도후기모두작성;
      
      return [
        {
          key: 'total',
          value: total,
          label: '메시지 총 발송건수',
          percent: '100',
          colorClass: 'purple',
          showFor: ['customer'],
          tooltip: selectedView.value === 'messageCount' 
            ? `<p><strong>📨 메시지 총 발송건수 (비용 관점)</strong></p>
               <p>카카오 알림톡 API로 전송 요청한 모든 건수입니다.</p>
               <br/>
               <p><strong>💰 비용 계산에 활용</strong></p>
               <ul>
                 <li>건당 15~20원의 발송 비용 × 총 건수</li>
                 <li>재발송, 실패 후 재시도 모두 비용 발생</li>
                 <li>예: 136,477건 × 15원 = 약 205만원</li>
               </ul>
               <br/>
               <p><strong>📊 이 수치가 높은 경우</strong></p>
               <ul>
                 <li>✅ 정상: 대규모 이벤트, 재발송 정책 적용</li>
                 <li>⚠️ 확인필요: 중복 발송이 과도하게 많음</li>
                 <li>💡 개선방안: 발송 대상 정제, 실패율 감소</li>
               </ul>`
            : `<p><strong>👥 실제 도달 대상자 (마케팅 관점)</strong></p>
               <p>실제로 메시지가 도달한 고유한 사용자 수입니다.</p>
               <br/>
               <p><strong>🎯 캠페인 효과 측정</strong></p>
               <ul>
                 <li>실제 몇 명에게 메시지가 전달되었는가</li>
                 <li>응답률 계산의 정확한 분모</li>
                 <li>예: 9,356명 응답 ÷ 131,482명 도달 = 7.1%</li>
               </ul>
               <br/>
               <p><strong>📈 활용 방법</strong></p>
               <ul>
                 <li>ROI 계산: 응답자당 획득 비용</li>
                 <li>타겟팅 효과: 세그먼트별 응답률 비교</li>
                 <li>최적화: 발송 시간대, 메시지 내용 개선</li>
               </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>집계 필드:</strong> eventattendees.messageSendHistory[]</p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
${selectedView.value === 'messageCount' 
  ? 'messageSendHistory 배열의 모든 요소 개수 합계'
  : 'messageSendHistory가 있는 고유 문서 수'}
(날짜 필터 적용 시: requestedAt이 기간 내인 것만)</pre>
                          <p><strong>데이터 출처:</strong> message-statistics API 재활용</p>`
        },
        {
          key: 'success',
          value: dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수,
          label: '알림톡 발송 건수',
          percent: calcPercent(dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수, total),
          colorClass: 'pink',
          showFor: ['customer'],
          tooltip: selectedView.value === 'messageCount'
            ? `<p><strong>✅ 발송 성공 건수 (시스템 관점)</strong></p>
               <p>카카오 API가 정상 처리한 메시지 건수입니다.</p>
               <br/>
               <p><strong>📱 성공의 의미</strong></p>
               <ul>
                 <li>카카오 서버가 메시지를 수락함</li>
                 <li>사용자 카카오톡으로 전송 대기 중</li>
                 <li>❗ 실제 읽음 여부와는 무관</li>
               </ul>
               <br/>
               <p><strong>🔍 성공률 분석</strong></p>
               <ul>
                 <li>현재: ${calcPercent(dashboardStats.알림톡발송성공건수, total)}% 성공</li>
                 <li>업계 평균: 95% 이상</li>
                 <li>90% 미만시 템플릿 검토 필요</li>
               </ul>
               <br/>
               <p><strong>💡 실패 원인 Top 3</strong></p>
               <ul>
                 <li>1️⃣ 수신거부 사용자 (080 거부)</li>
                 <li>2️⃣ 휴대폰 번호 오류</li>
                 <li>3️⃣ 템플릿 변수 불일치</li>
               </ul>`
            : `<p><strong>✅ 성공적으로 도달한 사용자 (사용자 관점)</strong></p>
               <p>메시지를 정상적으로 받을 수 있는 고유 사용자 수입니다.</p>
               <br/>
               <p><strong>📊 도달 가능 대상자</strong></p>
               <ul>
                 <li>총 ${dashboardStats.메시지발송시도건수.toLocaleString()}명 중 ${dashboardStats.알림톡발송성공건수.toLocaleString()}명</li>
                 <li>도달률: ${calcPercent(dashboardStats.알림톡발송성공건수, dashboardStats.메시지발송시도건수)}%</li>
                 <li>미도달: ${(dashboardStats.메시지발송시도건수 - dashboardStats.알림톡발송성공건수).toLocaleString()}명</li>
               </ul>
               <br/>
               <p><strong>🎯 마케팅 인사이트</strong></p>
               <ul>
                 <li>실제 캠페인 도달 범위</li>
                 <li>응답률 계산의 정확한 기준</li>
                 <li>타겟 정확도 평가 지표</li>
               </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>집계 필드:</strong> eventattendees.messageSendHistory[].status</p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
메시지발송시도건수 - 메시지발송실패건수
= totalMessages - failed</pre>
                          <p><strong>실패 조건:</strong> status가 'failed'인 메시지</p>`
        },
        {
          key: 'referralShares',
          value: dashboardStats.레퍼러로부터공유받은횟수 || 0,
          label: '공유받은 횟수',
          percent: `${(dashboardStats.레퍼러로부터공유받은횟수 || 0).toLocaleString()}회`,
          colorClass: 'orange',
          isPercent: false,
          showFor: ['customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>📤 공유받은 횟수</strong></p>
                    <p>친구로부터 이벤트 공유를 받은 총 횟수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>총 공유받은 횟수: ${(dashboardStats.레퍼러로부터공유받은횟수 || 0).toLocaleString()}회</li>
                      <li>응모한사람: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명</li>
                      <li>평균 공유받은 횟수: ${dashboardStats.응모한사람 > 0 ? (dashboardStats.레퍼러로부터공유받은횟수 / dashboardStats.응모한사람).toFixed(1) : '0.0'}회/명</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>바이럴 마케팅의 핵심 지표</li>
                      <li>친구 추천의 영향력 측정</li>
                      <li>이벤트 확산력 평가</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 레퍼러로부터공유받은횟수</p>
                          <p><strong>집계 방식:</strong> 친구로부터 공유받은 이벤트 횟수</p>
                          <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>`
        },
        {
          key: 'pageVisited',
          value: dashboardStats.이벤트페이지진입 || 0,
          label: '이벤트 페이지 진입',
          percent: calcPercent(dashboardStats.이벤트페이지진입 || 0, total),
          colorClass: 'cyan',
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>🎯 이벤트 페이지 진입자</strong></p>
                    <p>알림톡의 링크를 클릭하여 이벤트 페이지에 도착한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이벤트페이지진입 데이터 사용</li>
                      <li>페이지 진입자: ${(dashboardStats.이벤트페이지진입 || 0).toLocaleString()}명</li>
                      <li>메시지 대비 진입률: ${calcPercent(dashboardStats.이벤트페이지진입 || 0, total)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>메시지를 받고 실제로 관심을 보인 사용자</li>
                      <li>이벤트 참여의 첫 번째 단계</li>
                      <li>메시지 내용과 혜택의 매력도를 나타내는 지표</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 이벤트페이지진입</p>
                          <p><strong>집계 방식:</strong> 이벤트 페이지 진입 이벤트 카운트</p>
                          <p><strong>용도:</strong> 메시지 클릭률(CTR) 측정</p>
                          <p><strong>분석:</strong> 메시지 효과성과 사용자 관심도 평가</p>`
        },
        {
          key: 'kakaoShareCount',
          value: dashboardStats.카카오톡공유하기횟수 || 0,
          label: '카카오톡 공유하기 횟수',
          percent: calcPercent(dashboardStats.카카오톡공유하기횟수 || 0, dashboardStats.이벤트페이지진입 || 0),
          colorClass: 'yellow-light',
          isPercent: false,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>📱 카카오톡 공유하기 횟수</strong></p>
                    <p>이벤트 페이지에서 카카오톡으로 공유하기 버튼을 클릭한 총 횟수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>총 공유 횟수: ${(dashboardStats.카카오톡공유하기횟수 || 0).toLocaleString()}회</li>
                      <li>이벤트 페이지 진입: ${(dashboardStats.이벤트페이지진입 || 0).toLocaleString()}명</li>
                      <li>공유 비율: ${calcPercent(dashboardStats.카카오톡공유하기횟수 || 0, dashboardStats.이벤트페이지진입 || 0)}%</li>
                      <li>공유한 사용자: ${(dashboardStats.카카오톡공유한사람 || 0).toLocaleString()}명</li>
                      <li>평균 공유 횟수: ${dashboardStats.카카오톡공유한사람 > 0 ? (dashboardStats.카카오톡공유하기횟수 / dashboardStats.카카오톡공유한사람).toFixed(1) : '0.0'}회/명</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>이벤트 페이지 진입자 중 공유한 비율</li>
                      <li>이벤트의 바이럴 마케팅 효과를 나타내는 지표</li>
                      <li>사용자들이 이벤트를 친구들에게 공유한 비율</li>
                      <li>높을수록 이벤트의 인지도와 확산력이 좋음을 의미</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 카카오톡공유하기횟수</p>
                          <p><strong>집계 방식:</strong> 카카오톡 공유하기 버튼 클릭 이벤트 카운트</p>
                          <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>
                          <p><strong>분석:</strong> 이벤트 확산력과 사용자 참여도 평가</p>`
        },


        // {
        //   key: 'kakaoShareUsers',
        //   value: dashboardStats.카카오톡공유한사람 || 0,
        //   label: '카카오톡 공유한 사람',
        //   percent: calcPercent(dashboardStats.카카오톡공유한사람 || 0, total),
        //   colorClass: 'pink-light',
        //   tooltip: `<p><strong>📱 카카오톡 공유한 사람</strong></p>
        //             <p>이벤트 페이지에서 카카오톡으로 공유하기 버튼을 클릭한 사용자 수입니다.</p>
        //             <br/>
        //             <p><strong>📊 데이터 계산 방식</strong></p>
        //             <ul>
        //               <li>공유한 사용자: ${(dashboardStats.카카오톡공유한사람 || 0).toLocaleString()}명</li>
        //               <li>전체 응답자 대비 공유율: ${calcPercent(dashboardStats.카카오톡공유한사람 || 0, responseTotal)}%</li>
        //               <li>메시지 대비 공유율: ${calcPercent(dashboardStats.카카오톡공유한사람 || 0, total)}%</li>
        //             </ul>
        //             <br/>
        //             <p><strong>💡 데이터 의미</strong></p>
        //             <ul>
        //               <li>이벤트의 바이럴 마케팅 효과를 나타내는 지표</li>
        //               <li>사용자들이 이벤트를 친구들에게 공유한 비율</li>
        //               <li>높을수록 이벤트의 인지도와 확산력이 좋음을 의미</li>
        //             </ul>`,
        //   backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
        //                   <p><strong>데이터 소스:</strong> 카카오톡공유한사람</p>
        //                   <p><strong>집계 방식:</strong> 카카오톡 공유하기 버튼 클릭한 고유 사용자 수</p>
        //                   <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>
        //                   <p><strong>분석:</strong> 이벤트 확산력과 사용자 참여도 평가</p>`
        // },
        {
          key: 'participants',
          value: dashboardStats.응모한사람 || 0,
          label: '응모한사람',
          percent: calcPercent(dashboardStats.응모한사람 || 0, dashboardStats.이벤트페이지진입 || 0),
          colorClass: 'blue',
          isPercent: false,
          showFor: ['customer','customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>👥 응모한사람</strong></p>
                    <p>이벤트에 실제로 응모한 사용자 수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>응모한사람: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명</li>
                      <li>이벤트 페이지 진입: ${(dashboardStats.이벤트페이지진입 || 0).toLocaleString()}명</li>
                      <li>응모 비율: ${calcPercent(dashboardStats.응모한사람 || 0, dashboardStats.이벤트페이지진입 || 0)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>이벤트 페이지 진입자 중 실제 응모한 비율</li>
                      <li>이벤트에 참여한 고유 사용자 수</li>
                      <li>바이럴 마케팅의 핵심 지표</li>
                      <li>친구를 통해 이벤트를 알게 된 사용자</li>
                    </ul>
                    <br/>
                    <p><strong>💡 활용 방법</strong></p>
                    <ul>
                      <li>바이럴 마케팅 효과 측정</li>
                      <li>친구 추천의 영향력 평가</li>
                      <li>이벤트 확산력 분석</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 응모한사람</p>
                          <p><strong>집계 방식:</strong> 이벤트에 응모한 고유 사용자 수</p>
                          <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>`
        },
        {
          key: 'reviewUsers',
          value: dashboardStats.후기남긴사람 || 0,
          label: '후기 남긴 사람',
          percent: calcPercent(dashboardStats.후기남긴사람 || 0, total),
          colorClass: 'green-light',
          showFor: ['customer'],
          tooltip: `<p><strong>✍️ 후기 남긴 사람</strong></p>
                    <p>이벤트에서 후기를 작성한 사용자 수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>후기만 작성: ${(dashboardStats.후기만작성 || 0).toLocaleString()}명</li>
                      <li>만족도+후기 모두 작성: ${(dashboardStats.만족도후기모두작성 || 0).toLocaleString()}명</li>
                      <li>총 후기 작성자: ${(dashboardStats.후기남긴사람 || 0).toLocaleString()}명</li>
                      <li>전체 응답자 대비 후기율: ${calcPercent(dashboardStats.후기남긴사람 || 0, responseTotal)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>텍스트 후기를 작성한 사용자 비율</li>
                      <li>이벤트 참여의 질적 지표</li>
                      <li>사용자 만족도와 참여 의지 평가</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 후기남긴사람</p>
                          <p><strong>집계 방식:</strong> 후기를 작성한 고유 사용자 수</p>
                          <p><strong>용도:</strong> 후기 작성 참여율 측정</p>
                          <p><strong>분석:</strong> 사용자 참여도와 콘텐츠 생성 효과 평가</p>`
        },
        {
          key: 'shareAndReviewUsers',
          value: dashboardStats.공유후기남긴사람 || 0,
          label: '공유+후기 남긴 사람',
          percent: calcPercent(dashboardStats.공유후기남긴사람 || 0, total),
          colorClass: 'purple-light',
          showFor: ['customer'],
          tooltip: `<p><strong>🎯 공유+후기 남긴 사람</strong></p>
                    <p>카카오톡 공유와 후기 작성을 모두 완료한 사용자 수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>공유+후기 모두 완료: ${(dashboardStats.공유후기남긴사람 || 0).toLocaleString()}명</li>
                      <li>전체 응답자 대비 완료율: ${calcPercent(dashboardStats.공유후기남긴사람 || 0, responseTotal)}%</li>
                      <li>후기 작성자 대비 완료율: ${calcPercent(dashboardStats.공유후기남긴사람 || 0, dashboardStats.후기남긴사람 || 0)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>가장 적극적으로 참여한 핵심 고객</li>
                      <li>이벤트의 최종 목표 달성 지표</li>
                      <li>보상 지급의 주요 대상</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 공유후기남긴사람</p>
                          <p><strong>집계 방식:</strong> 카카오톡 공유와 후기를 모두 완료한 고유 사용자 수</p>
                          <p><strong>용도:</strong> 이벤트 완료율 측정</p>
                          <p><strong>분석:</strong> 최종 참여 목표 달성도 평가</p>`
        },
        // customer_friend, friend_of_friend용 새로운 카드들
        {
          key: 'rate',
          value: calcPercent(responseTotal, dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수),
          label: '전체 참여율',
          percent: `응답: ${responseTotal.toLocaleString()}명`,
          colorClass: 'cyan-light',
          isPercent: true,
          showFor: ['customer'],
          tooltip: `<p><strong>📊 전체 참여율</strong></p>
                    <p>메시지를 받은 사람 중 실제로 이벤트에 참여한 비율입니다.</p>
                    <ul>
                      <li>계산식: 응모한사람 ÷ 알림톡발송성공건수 × 100</li>
                      <li>이벤트의 전반적인 성과를 나타내는 핵심 지표</li>
                      <li>높을수록 성공적인 캠페인으로 평가됩니다</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
(응모한사람 / 알림톡발송성공건수) × 100</pre>
                          <p><strong>용도:</strong> 이벤트 성과의 핵심 KPI</p>
                          <p><strong>분석:</strong> 메시지 효과성과 참여 유도력 평가</p>`
        },
        {
          key: 'rateForFriends',
          value: calcPercent(dashboardStats.응모한사람 || 0, dashboardStats.레퍼러로부터공유받은횟수 || 0),
          label: '전체 참여율',
          percent: `응답: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명`,
          colorClass: 'cyan-light',
          isPercent: true,
          showFor: ['customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>📊 전체 참여율</strong></p>
                    <p>공유받은 횟수 대비 응모한 비율입니다.</p>
                    <ul>
                      <li>계산식: 응모한사람 ÷ 공유받은횟수 × 100</li>
                      <li>바이럴 마케팅의 전반적인 성과를 나타내는 핵심 지표</li>
                      <li>높을수록 성공적인 바이럴 캠페인으로 평가됩니다</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
(응모한사람 / 레퍼러로부터공유받은횟수) × 100</pre>
                          <p><strong>용도:</strong> 바이럴 마케팅 성과의 핵심 KPI</p>
                          <p><strong>분석:</strong> 친구 추천 효과성과 참여 유도력 평가</p>`
        }
      ];
    };
    
    // 퍼널 데이터 계산
    const getFunnelData = () => {
      // 사용자 타입에 따라 다른 기준 사용
      const isCustomerType = selectedUserType.value === 'customer';
      const total = isCustomerType ? dashboardStats.메시지발송시도건수 : dashboardStats.레퍼러로부터공유받은횟수;
      
      // 전체 현황 요약 데이터를 기준으로 사용
      const messageSent = total;
      const kakaoSuccess = isCustomerType ? (dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수) : (dashboardStats.레퍼러로부터공유받은횟수 || 0);
      const pageVisited = dashboardStats.이벤트페이지진입 || 0;
      const kakaoShare = dashboardStats.카카오톡공유하기횟수 || 0;
      const hospitalPageEntered = dashboardStats.병원페이지진입 || 0;
      
      // API 데이터에서 직접 가져오기
      const satisfactionOrReview = dashboardStats.만족도만작성 + dashboardStats.후기만작성 + dashboardStats.만족도후기모두작성;
      const completeAll = dashboardStats.만족도후기모두작성;
      
      const funnelData = [
        {
          key: 'target',
          number: isCustomerType ? messageSent : total,
          desc: '이벤트 대상자',
          percent: '100',
          width: 100,
          colorClass: 'green',
          change: 0,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: (selectedView.value === 'messageCount'
              ? `<p><strong>1️⃣ 메시지 발송 요청</strong></p>
                 <p>시스템에 메시지 발송을 요청한 총 건수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>eventattendees.messageSendHistory 배열의 모든 요소 개수</li>
                   <li>중복 발송 포함: 한 사용자에게 여러 번 발송 시 각각 집계</li>
                   <li>재발송 포함: 실패 후 재시도한 건수도 포함</li>
                   <li>상태 무관: requested, sent, failed 모두 포함</li>
                 </ul>
                 <br/>
                 <p><strong>💰 비용 관련</strong></p>
                 <ul>
                   <li>총 ${(messageSent || 0).toLocaleString()}건 × 15원 = ${((messageSent || 0) * 15).toLocaleString()}원</li>
                   <li>실패 건수도 비용 발생</li>
                   <li>카카오 알림톡 API 과금 기준</li>
                 </ul>`
              : `<p><strong>1️⃣ 이벤트 대상자</strong></p>
                 <p>메시지를 받은 고유한 사용자 수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>eventattendees 컬렉션의 고유 문서 수</li>
                   <li>messageSendHistory가 있는 참석자만 집계</li>
                   <li>중복 제거: 한 사용자가 여러 번 받아도 1명으로 집계</li>
                   <li>customerId 기준으로 중복 제거</li>
                 </ul>
                 <br/>
                 <p><strong>📈 중복 발송 현황</strong></p>
                 <ul>
                   <li>총 발송: ${viewOptions.value?.messageCount?.data?.메시지발송시도건수?.toLocaleString() || '136,477'}건</li>
                   <li>고유 대상: ${(messageSent || 0).toLocaleString()}명</li>
                   <li>중복 발송: ${((viewOptions.value?.messageCount?.data?.메시지발송시도건수 || 136477) - (messageSent || 0)).toLocaleString()}건</li>
                   <li>평균 발송 횟수: ${((viewOptions.value?.messageCount?.data?.메시지발송시도건수 || 136477) / (messageSent || 1)).toFixed(1)}회/명</li>
                 </ul>`)
        },
        {
          key: 'sent',
          number: kakaoSuccess,
          desc: '카카오톡 알림<br>발송 성공',
          percent: calcPercent(kakaoSuccess, messageSent),
          width: parseFloat(calcPercent(kakaoSuccess, messageSent)),
          colorClass: 'blue',
          change: messageSent - kakaoSuccess,
          showFor: ['customer'] ,
          tooltip: (selectedView.value === 'messageCount'
              ? `<p><strong>2️⃣ 카카오톡 발송 성공</strong></p>
                 <p>카카오 API가 성공적으로 처리한 메시지 건수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>이전 단계: ${(messageSent || 0).toLocaleString()}건 (발송 요청)</li>
                   <li>현재 단계: ${(kakaoSuccess || 0).toLocaleString()}건 (발송 성공)</li>
                   <li>실패: ${((messageSent || 0) - (kakaoSuccess || 0)).toLocaleString()}건</li>
                   <li>성공률: ${calcPercent(kakaoSuccess, messageSent)}%</li>
                 </ul>
                 <br/>
                 <p><strong>❌ 실패 내역</strong></p>
                 <ul>
                   <li>총 실패: ${((messageSent || 0) - (kakaoSuccess || 0)).toLocaleString()}건</li>
                   <li>messageSendHistory에서 status='failed'인 건수</li>
                   <li>주요 원인: 수신거부, 번호오류, 템플릿 오류 등</li>
                 </ul>`
              : `<p><strong>2️⃣ 메시지 도달 가능 사용자</strong></p>
                 <p>카카오톡을 정상적으로 받을 수 있는 고유 사용자 수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>이전 단계: ${(messageSent || 0).toLocaleString()}명 (전체 대상)</li>
                   <li>현재 단계: ${(kakaoSuccess || 0).toLocaleString()}명 (도달 가능)</li>
                   <li>도달 불가: ${((messageSent || 0) - (kakaoSuccess || 0)).toLocaleString()}명</li>
                   <li>도달률: ${calcPercent(kakaoSuccess, messageSent)}%</li>
                 </ul>
                 <br/>
                 <p><strong>📝 집계 방식</strong></p>
                 <ul>
                   <li>eventattendees에서 최종 status='sent'인 고유 사용자</li>
                   <li>재발송 시도 후 최종 성공한 경우도 포함</li>
                   <li>중복 제거: 여러 번 성공해도 1명으로 집계</li>
                 </ul>`)
        },
        {
          key: 'pageVisited',
          number: pageVisited,
          desc: '이벤트 페이지<br>진입',
          percent: calcPercent(pageVisited, messageSent),
          width: parseFloat(calcPercent(pageVisited, messageSent)),
          colorClass: 'yellow',
          change: kakaoSuccess - pageVisited,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>3️⃣ 이벤트 페이지 진입</strong></p>
                    <p>알림톡의 링크를 클릭하여 이벤트 페이지에 도착한 ${selectedView.value === 'messageCount' ? '횟수' : '사용자 수'}입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이전 단계: ${kakaoSuccess.toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'} (발송 성공)</li>
                      <li>현재 단계: ${pageVisited.toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'} (페이지 도착)</li>
                      <li>미클릭: ${(kakaoSuccess - pageVisited).toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'}</li>
                      <li>클릭률(CTR): ${calcPercent(pageVisited, kakaoSuccess)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 클릭률(CTR) 의미</strong></p>
                    <ul>
                      <li>메시지를 받은 사용자 중 실제로 관심을 보인 비율</li>
                      <li>메시지 내용과 혜택의 매력도를 나타내는 지표</li>
                      <li>일반적으로 15~25%가 양호한 수준</li>
                    </ul>`
        },
        {
          key: 'participants',
          number: dashboardStats.응모한사람 || 0,
          desc: '응모한사람',
          percent: calcPercent(dashboardStats.응모한사람 || 0, messageSent),
          width: parseFloat(calcPercent(dashboardStats.응모한사람 || 0, messageSent)),
          colorClass: 'orange',
          change: pageVisited - (dashboardStats.응모한사람 || 0),
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>4️⃣ 응모한사람</strong></p>
                    <p>이벤트 페이지에 진입한 후 실제로 이벤트에 응모한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이전 단계: ${pageVisited.toLocaleString()}명 (이벤트 페이지 진입)</li>
                      <li>현재 단계: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명 (실제 응모)</li>
                      <li>미응모: ${(pageVisited - (dashboardStats.응모한사람 || 0)).toLocaleString()}명</li>
                      <li>응모율: ${calcPercent(dashboardStats.응모한사람 || 0, pageVisited)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 응모율 의미</strong></p>
                    <ul>
                      <li>이벤트 페이지에 진입한 사용자 중 실제 응모한 비율</li>
                      <li>이벤트의 매력도와 참여 유도력을 나타내는 지표</li>
                      <li>높을수록 이벤트 설계가 성공적임을 의미</li>
                    </ul>`
        },
        {
          key: 'response',
          number: satisfactionOrReview,
          desc: '만족도/후기<br>응답',
          percent: calcPercent(satisfactionOrReview, messageSent),
          width: parseFloat(calcPercent(satisfactionOrReview, messageSent)),
          colorClass: 'red',
          change: (dashboardStats.응모한사람 || 0) - satisfactionOrReview,
          showFor: ['customer'],
          tooltip: `<div style="max-width: 800px;">
                    <p><strong>5️⃣ 만족도/후기 응답자</strong></p>
                    <p>만족도 또는 후기 중 하나라도 작성하여 이벤트에 실제 참여한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>만족도만 작성: ${dashboardStats.만족도만작성.toLocaleString()}명</li>
                      <li>후기만 작성: ${dashboardStats.후기만작성.toLocaleString()}명</li>
                      <li>둘 다 작성: ${dashboardStats.만족도후기모두작성.toLocaleString()}명</li>
                      <li>총 유효 응답자: ${satisfactionOrReview.toLocaleString()}명</li>
                      <li>전체 대비 비율: ${calcPercent(satisfactionOrReview, messageSent)}%</li>
                    </ul>
                    <br/>
                    <p><strong>📋 응답 유형별 분류</strong></p>
                    <ul>
                      <li>만족도만 작성: ${(dashboardStats.만족도만작성 || 0).toLocaleString()}명 (${calcPercent(dashboardStats.만족도만작성 || 0, satisfactionOrReview)}%)</li>
                      <li>후기만 작성: ${(dashboardStats.후기만작성 || 0).toLocaleString()}명 (${calcPercent(dashboardStats.후기만작성 || 0, satisfactionOrReview)}%)</li>
                      <li>둘 다 작성: ${(dashboardStats.만족도후기모두작성 || 0).toLocaleString()}명 (${calcPercent(dashboardStats.만족도후기모두작성 || 0, satisfactionOrReview)}%)</li>
                    </ul>
                    <br/>
                    <p><strong>⚠️ 비정상 데이터란?</strong></p>
                    <ul>
                      <li>reviews 컬렉션에 score 필드만 있고 satisfactionPoints나 content가 없는 레코드</li>
                      <li>집계에서 제외되며 보상 지급 대상에서도 제외됩니다</li>
                      <li>백엔드 API의 abnormalDataCount 필드로 확인 가능</li>
                    </ul>
                  </div>`,
          warningTooltip: `<div style="max-width: 800px;">
                    <p><strong>❗ 전체 응답자 수 차이에 대한 상세 설명</strong></p>
                    <br/>
                    <p><strong>두 가지 집계 방식의 차이:</strong></p>
                    <ul>
                      <li>대시보드 "응모한사람": ${(dashboardStats.응모한사람 || 0).toLocaleString()}명 (고유 고객 기준)</li>
                      <li>후기 목록 화면 total: 9,455건 (전체 리뷰 문서 기준)</li>
                      <li>차이: 99건</li>
                    </ul>
                    <br/>
                    <p><strong>차이가 발생하는 이유:</strong></p>
                    <p><strong>1. 집계 기준의 근본적 차이</strong></p>
                    <ul>
                      <li>대시보드: eventattendees 컬렉션 (고유 고객 수)</li>
                      <li>후기 목록: reviews 컬렉션 (리뷰 문서 수)</li>
                    </ul>
                    <br/>
                    <p><strong>2. 중복 발생 원인</strong></p>
                    <ul>
                      <li>한 고객이 여러 리뷰 작성 (특수 케이스)</li>
                      <li>시스템 오류로 인한 중복 생성</li>
                      <li>API 재시도로 인한 중복</li>
                    </ul>
                    <br/>
                    <p><strong>3. 데이터 검증을 위한 MongoDB 쿼리</strong></p>
                    <div style="position: relative;">
                      <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">// 1. reviews 컬렉션의 중복 확인
db.reviews.aggregate([
  { $match: { eventId: "684ffa949e3fcf1da5c86a9f" } },
  { $group: {
    _id: "$customerId",
    count: { $sum: 1 },
    reviews: { $push: "$$ROOT" }
  }},
  { $match: { count: { $gt: 1 } } },
  { $sort: { count: -1 } }
])

// 2. eventattendees와 reviews 비교
db.eventattendees.aggregate([
  { $match: { eventId: "684ffa949e3fcf1da5c86a9f" } },
  { $lookup: {
    from: "reviews",
    localField: "customerId",
    foreignField: "customerId",
    as: "reviews"
  }},
  { $addFields: { reviewCount: { $size: "$reviews" } } },
  { $match: { reviewCount: { $ne: 1 } } }
])</pre>
                      <button 
                        onclick="navigator.clipboard.writeText(this.previousElementSibling.textContent); this.textContent='복사됨!'; setTimeout(() => this.textContent='쿼리 복사', 2000)" 
                        style="position: absolute; top: 8px; right: 8px; background: #1890ff; color: white; border: none; padding: 4px 12px; border-radius: 4px; cursor: pointer; font-size: 12px;"
                      >쿼리 복사</button>
                    </div>
                    <br/>
                    <p><strong>✅ 결론</strong></p>
                    <p>두 수치의 차이는 정상적인 현상이며, 각각 다른 목적으로 사용됩니다:</p>
                    <ul>
                      <li>대시보드: 실제 참여한 고유 고객 수 파악 (마케팅 지표)</li>
                      <li>후기 목록: 생성된 모든 리뷰 관리 (콘텐츠 관리)</li>
                    </ul>
                  </div>`
        },
        {
          key: 'complete',
          number: completeAll,
          desc: '만족도+후기<br>모두 응답',
          percent: calcPercent(completeAll, messageSent),
          width: parseFloat(calcPercent(completeAll, messageSent)),
          colorClass: 'purple',
          change: satisfactionOrReview - completeAll,
          showFor: ['customer'],
          tooltip: `<p><strong>6️⃣ 만족도+후기 모두 응답</strong></p>
                    <p>만족도와 후기를 모두 작성하여 이벤트를 완전히 완료한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이전 단계: ${(satisfactionOrReview || 0).toLocaleString()}명 (둘 중 하나라도 작성)</li>
                      <li>현재 단계: ${(completeAll || 0).toLocaleString()}명 (둘 다 작성)</li>
                      <li>부분 참여자: ${((satisfactionOrReview || 0) - (completeAll || 0)).toLocaleString()}명</li>
                      <li>완료율: ${calcPercent(completeAll, satisfactionOrReview)}%</li>
                    </ul>
                    <br/>
                    <p><strong>📈 전체 퍼널 요약</strong></p>
                    <ul>
                      <li>시작: ${(messageSent || 0).toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'}</li>
                      <li>종료: ${(completeAll || 0).toLocaleString()}명</li>
                      <li>최종 전환율: ${calcPercent(completeAll, messageSent)}%</li>
                      <li>단계별 최대 이탈: ${Math.max((messageSent || 0) - (kakaoSuccess || 0), (kakaoSuccess || 0) - (pageVisited || 0), (pageVisited || 0) - (dashboardStats.응모한사람 || 0), (dashboardStats.응모한사람 || 0) - (satisfactionOrReview || 0), (satisfactionOrReview || 0) - (completeAll || 0), (completeAll || 0) - (hospitalPageEntered || 0)).toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'}</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>이 사용자들이 가장 적극적으로 참여한 핵심 고객입니다</li>
                      <li>만족도 점수와 텍스트 후기를 모두 제공하여 가장 가치 있는 피드백을 제공합니다</li>
                      <li>보상 지급의 주요 대상이며, 향후 이벤트 참여 가능성이 높습니다</li>
                    </ul>`
        },
        {
          key: 'hospital',
          number: hospitalPageEntered,
          desc: '병원 페이지<br>진입',
          percent: calcPercent(hospitalPageEntered, isCustomerType?messageSent:total),
          width: parseFloat(calcPercent(hospitalPageEntered, isCustomerType?messageSent:total)),
          colorClass: 'indigo',
          change: completeAll - hospitalPageEntered,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>7️⃣ 병원 페이지 진입</strong></p>
                    <p>"자이스 스마일 더 알아보기" 버튼을 클릭하여 병원 정보 페이지에 진입한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이전 단계: ${(completeAll || 0).toLocaleString()}명 (만족도+후기 모두 작성)</li>
                      <li>현재 단계: ${(hospitalPageEntered || 0).toLocaleString()}명 (병원 페이지 진입)</li>
                      <li>진입하지 않음: ${((completeAll || 0) - (hospitalPageEntered || 0)).toLocaleString()}명</li>
                      <li>진입율: ${calcPercent(hospitalPageEntered, completeAll)}%</li>
                    </ul>
                    <br/>
                    <p><strong>🎯 마케팅 효과</strong></p>
                    <ul>
                      <li>이벤트 참여 후 실제 병원 정보에 관심을 보인 고객</li>
                      <li>수술 상담이나 예약으로 이어질 가능성이 높음</li>
                      <li>가장 높은 전환 가능성을 가진 고객 그룹</li>
                    </ul>
                    <br/>
                    <p><strong>📈 전체 퍼널 최종 요약</strong></p>
                    <ul>
                      <li>시작: ${(messageSent || 0).toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'}</li>
                      <li>최종: ${(hospitalPageEntered || 0).toLocaleString()}명 (병원 페이지 진입)</li>
                      <li>최종 전환율: ${calcPercent(hospitalPageEntered, messageSent)}%</li>
                    </ul>`
        }
      ];
      
      // showFor 속성에 따라 필터링
      return funnelData.filter(item => {
        if (!item.showFor) return true;
        return item.showFor.includes(selectedUserType.value);
      });
    };
    
    // 날짜 필터 옵션
    const dateFilterOptions = [
      { label: '전체', value: 'all' },
      { label: '오늘', value: 'today' },
      { label: '1주일', value: 'week' },
      { label: '1개월', value: 'month' }
    ];
    
    // 병원별 집계 테이블 컬럼
    const hospitalColumns = [
      {
        title: '순위',
        dataIndex: 'rank',
        key: 'rank',
        width: 60,
        align: 'center',
        fixed: 'left'
      },
      {
        title: () => h('span', [
          '병원명',
          h(Tooltip, {
            title: '이벤트에 참여한 병원명입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: 'hospitalName',
        key: 'hospitalName',
        width: 180,
        fixed: 'left'
      },
      {
        title: () => h('span', [
          '응모한사람',
          h(Tooltip, {
            title: '해당 병원에서 이벤트에 응모한 전체 고객 수입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: '응모한사람',
        key: '응모한사람',
        width: 110,
        align: 'right',
        customRender: ({ text }) => text.toLocaleString()
      },
      {
        title: () => h('span', [
          '만족도/후기 응답',
          h(Tooltip, {
            title: '만족도 또는 후기 중 하나라도 응답한 고객 수입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: '만족도/후기작성',
        key: '만족도/후기작성',
        width: 140,
        align: 'right',
        customRender: ({ text }) => text.toLocaleString()
      },
      {
        title: () => h('span', [
          '만족도+후기 모두 응답',
          h(Tooltip, {
            title: '만족도와 후기를 모두 응답하여 이벤트를 완전히 완료한 고객 수입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: '만족도,후기모두작성',
        key: '만족도,후기모두작성',
        width: 160,
        align: 'right',
        customRender: ({ text }) => text.toLocaleString()
      },
      {
        title: () => h('span', [
          '완전작성률',
          h(Tooltip, {
            title: '전체응답자 중 만족도와 후기를 모두 작성한 비율입니다. (만족도+후기 모두 응답 ÷ 전체응답자 × 100)'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: 'completionRate',
        key: 'completionRate',
        width: 120,
        align: 'center',
        sorter: (a, b) => a.completionRate - b.completionRate
      }
    ];
    
    // 병원별 집계 테이블 데이터
    const hospitalTableData = computed(() => {
      if (!viewOptions.value || !viewOptions.value[selectedView.value]?.data?.hospitalBreakdown) {
        return [];
      }
      
      const hospitals = viewOptions.value[selectedView.value].data.hospitalBreakdown;
      
      return hospitals.map((hospital, index) => ({
        key: hospital.hospitalId,
        rank: index + 1,
        ...hospital,
        completionRate: hospital['응모한사람'] > 0 
          ? parseFloat(((hospital['만족도,후기모두작성'] / hospital['응모한사람']) * 100).toFixed(1))
          : 0
      }));
    });
    
    // 뒤로가기
    const goBack = () => {
      router.push('/events/management');
    };
    
    // 마운트 시 실행
    onMounted(() => {
      // API 인스턴스 초기화
      apiInstance.value = eventsApis(axios, store);
      
      eventId.value = route.params.eventId || route.query.eventId;
      
      if (!eventId.value) {
        message.error('이벤트 ID가 없습니다.');
        router.push('/events/management');
        return;
      }
      
      // localStorage에서 저장된 사용자 타입 설정 가져오기
      const savedUserType = localStorage.getItem('eventStatsUserType');
      console.log('저장된 사용자 타입:', savedUserType);
      if (savedUserType && (savedUserType === 'customer' || savedUserType === 'customer_friend' || savedUserType === 'friend_of_friend')) {
        selectedUserType.value = savedUserType;
      }
      console.log('현재 selectedUserType 값:', selectedUserType.value);
      
      // localStorage에서 저장된 데이터 뷰 설정 가져오기
      const savedView = localStorage.getItem('eventStatsView');
      console.log('저장된 데이터 뷰 설정:', savedView);
      if (savedView && (savedView === 'uniqueRecipient' || savedView === 'messageCount')) {
        selectedView.value = savedView;
      }
      console.log('현재 selectedView 값:', selectedView.value);
      
      // 이벤트 정보 조회
      loadEventDetails();
      
      // 대시보드 통계 조회
      loadDashboardStatistics();
    });
    
          return {
        eventTitle,
        loading,
        loadingStats,
        dashboardStats,
        dateRange,
        dateFilter,
        dateFilterOptions,
        selectedView,
        selectedUserType,
        viewOptions,
        setDateRange,
        handleDateChange,
        handleViewChange,
        handleUserTypeChange,
        calcPercent,
        getStatCards,
        getVisibleStatCards,
        getFunnelData,
        shouldShowCard,
        goBack,
        hospitalColumns,
        hospitalTableData
      };
  }
};
</script>

<style scoped lang="scss">
.titleContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  width: 100%;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.date-filter {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f5f5f5;
  padding: 8px 16px;
  border-radius: 8px;
}

.date-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
}

.date-filter-buttons {
  display: flex;
  gap: 4px;
  
  .ant-btn {
    height: 28px;
    padding: 0 12px;
    font-size: 13px;
    
    &.ant-btn-primary {
      background-color: #1890ff;
      border-color: #1890ff;
    }
  }
}

:deep(.ant-picker-range) {
  height: 32px;
  
  .ant-picker-input > input {
    font-size: 13px;
  }
}

.page-title {
  color: #000;
  font-size: 1.8rem;
  margin: 0;
}

.back-button {
  background-color: #f0f0f0;
  border: 1px solid #d9d9d9;
  color: #595959;
  
  &:hover {
    background-color: #e6e6e6;
    border-color: #d9d9d9;
    color: #595959;
  }
}

.pageDesc {
  font-size: 14px;
  color: #595959;
  margin-top: 8px;
  display: block;
}

.card {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: none;
  overflow: hidden;
}

.content-wrap-card {
  margin-top: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  display: flex;
  align-items: center;
}

.content-section {
  padding: 40px 20px;
}

.loading-state {
  text-align: center;
  padding: 60px 20px;
  
  p {
    margin-top: 16px;
    font-size: 14px;
    color: #595959;
  }
}

// 통계 섹션
.stats-section {
  margin-bottom: 40px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.stats-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #666;
  }
  
  .help-icon,
  .backend-icon {
    font-size: 14px;
    color: #999;
    cursor: pointer;
    margin-left: 4px;
    
    &:hover {
      color: #1890ff;
    }
  }
  
  .backend-icon {
    color: #ff8800;
    
    &:hover {
      color: #ff6600;
    }
  }
  
  .view-switcher {
    margin-left: auto;
    
    :deep(.ant-radio-button-wrapper) {
      height: 28px;
      line-height: 26px;
      padding: 0 12px;
      font-size: 13px;
      
      &.ant-radio-button-wrapper-checked {
        background-color: #1890ff;
        border-color: #1890ff;
        color: white;
        
        &:hover {
          background-color: #40a9ff;
          border-color: #40a9ff;
        }
      }
    }
  }
}

.stats-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

// 전체 현황 요약 카드
.stats-row {
  display: grid;
  gap: 12px;
  margin-bottom: 40px;
  
  // customer (시술받은 환자) - 7개 카드
  &.user-type-customer {
    grid-template-columns: repeat(8, 1fr);
  }
  
  // customer_friend (환자의 친구) - 5개 카드
  &.user-type-customer_friend {
    grid-template-columns: repeat(5, 1fr);
  }
  
  // friend_of_friend (친구의 친구) - 5개 카드
  &.user-type-friend_of_friend {
    grid-template-columns: repeat(5, 1fr);
  }
}

.stat-card {
  border-radius: 12px;
  padding: 24px 16px;
  text-align: center;
  color: white;
  position: relative;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0.1) 100%);
    pointer-events: none;
  }
  
  &.purple {
    background: linear-gradient(135deg, #8b8ee5 0%, #7c7fdb 100%);
  }
  
  &.pink {
    background: linear-gradient(135deg, #ff8fc3 0%, #ff7eb3 100%);
  }
  
  &.cyan {
    background: linear-gradient(135deg, #00d4e4 0%, #00bcd4 100%);
  }

  &.blue {
    background: linear-gradient(135deg, #1890ff 0%, #1890ff 100%);
  }
  
  &.purple-light {
    background: linear-gradient(135deg, #a8abe5 0%, #9c9fdb 100%);
  }
  
  &.blue-light {
    background: linear-gradient(135deg, #1890ff 0%, #1890ff 100%);
  }
  
  &.pink-light {
    background: linear-gradient(135deg, #ffaed3 0%, #ff9ec3 100%);
  }
  
  &.cyan-light {
    background: linear-gradient(135deg, #00e4f4 0%, #00d4e4 100%);
  }
  
  &.yellow-light {
    background: linear-gradient(135deg, #ffd666 0%, #ffc53d 100%);
  }
  
  &.pink-light {
    background: linear-gradient(135deg, #ffadd2 0%, #ff85c0 100%);
  }
  
  &.green-light {
    background: linear-gradient(135deg, #95de64 0%, #73d13d 100%);
  }
  
  &.purple-light {
    background: linear-gradient(135deg, #b37feb 0%, #9254de 100%);
  }
  
  &.orange {
    background: linear-gradient(135deg, #ff7a45 0%, #ff4d4f 100%);
  }
  
  .stat-icons {
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    gap: 6px;
    z-index: 2;
  }
  
  .stat-help-icon,
  .stat-backend-icon {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
  
  .stat-backend-icon {
    color: rgba(255, 255, 255, 0.6);
  }
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
  position: relative;
  z-index: 1;
}

.stat-desc {
  font-size: 13px;
  margin-bottom: 12px;
  opacity: 0.95;
  line-height: 1.3;
  position: relative;
  z-index: 1;
}

.stat-percent {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.9;
  position: relative;
  z-index: 1;
}

// 퍼널 스타일
.funnel-stats {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  overflow-x: auto;
  padding-bottom: 16px;
}

.funnel-item {
  flex: 1;
  min-width: 150px;
  position: relative;
  
  &.green .funnel-bar {
    background: #52c41a;
  }
  
  &.blue .funnel-bar {
    background: #1890ff;
  }
  
  &.yellow .funnel-bar {
    background: #faad14;
  }
  
  &.orange .funnel-bar {
    background: #fa8c16;
  }
  
  &.red .funnel-bar {
    background: #f5222d;
  }
  
  &.purple .funnel-bar {
    background: #722ed1;
  }
  
  &.indigo .funnel-bar {
    background: #6366f1;
  }
  
  &:last-child .funnel-arrow {
    display: none;
  }
  
  .funnel-help-icon {
    position: absolute;
    top: 15px;
    right: 10px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    z-index: 10;
    background: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    &:hover {
      color: #1890ff;
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    }
  }
  
  .funnel-warning-icon {
    position: absolute;
    top: 15px;
    right: 35px;
    font-size: 14px;
    color: #f5222d;
    cursor: pointer;
    z-index: 10;
    background: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    &:hover {
      color: #ff4d4f;
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    }
  }
}

.funnel-arrow {
  position: absolute;
  right: -32px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  font-weight: 700;
  color: #8c8c8c;
  z-index: 1;
}

.funnel-bar {
  height: 8px;
  border-radius: 4px;
  margin-bottom: 16px;
  margin-top: 35px;
  transition: width 0.3s ease;
  position: relative;
}

.funnel-content {
  text-align: center;
}

.funnel-number {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.funnel-desc {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.4;
}

.funnel-percent {
  font-size: 18px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 4px;
}

.funnel-change {
  font-size: 12px;
  color: #f5222d;
  font-weight: 500;
}


// 반응형 디자인
@media (max-width: 1200px) {
  .stats-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .stat-number {
    font-size: 24px;
  }
  
  .funnel-stats {
    flex-direction: column;
    align-items: stretch;
  }
  
  .funnel-item {
    width: 100%;
    margin-bottom: 24px;
  }
  
  .funnel-bar {
    width: 100% !important;
  }
}

// 병원별 집계 테이블 스타일
.hospital-table-wrapper {
  margin-top: 24px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.hospital-breakdown-table {
  :deep(.ant-table-thead > tr > th) {
    background: #fafafa;
    font-weight: 600;
    color: #262626;
    border-bottom: 2px solid #f0f0f0;
  }
  
  :deep(.ant-table-tbody > tr > td) {
    padding: 12px 16px;
  }
  
  :deep(.ant-table-tbody > tr:hover > td) {
    background: #f8faff;
  }
}

.hospital-name {
  font-weight: 500;
  color: #262626;
}

.completion-rate {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .rate-value {
    font-weight: 600;
    color: #1890ff;
    min-width: 45px;
    text-align: right;
  }
  
  .rate-bar {
    flex: 1;
    height: 6px;
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
    
    .rate-fill {
      height: 100%;
      background: linear-gradient(90deg, #40a9ff 0%, #1890ff 100%);
      transition: width 0.3s ease;
      border-radius: 3px;
    }
  }
}

// 순위별 강조 스타일
:deep(.ant-table-tbody > tr:nth-child(1)) {
  .hospital-name {
    color: #fa8c16;
    font-weight: 600;
  }
}

:deep(.ant-table-tbody > tr:nth-child(2)) {
  .hospital-name {
    color: #1890ff;
    font-weight: 600;
  }
}

:deep(.ant-table-tbody > tr:nth-child(3)) {
  .hospital-name {
    color: #52c41a;
    font-weight: 600;
  }
}
</style>